import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import MainWrapper from "../../../layouts/MainWrapper";
import CardWrapper from "../../../layouts/CardWrapper";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import { EditIcon } from "../../../components/SVGIcon";
import { useState, useEffect, useContext } from "react";
import { useAlert } from "../../../contexts/AlertContext";
import { singleUser, updateUser, updateProfilePic, updateUserstatus } from "../../../services/userService";
import UserStatusDropDown from "../../../components/UserStatusDropDown";
import { AppContext } from "../../../contexts/AppContext";

/* For validation */
import * as Yup from "yup";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import ImagePreviewLightbox from "../../../components/ImagePreviewLightbox";


const ProfileOverviewExpertise = ({ auth }) => {

  const [expertiseList, setExpertiseList] = useState([]);
  const [userData, setUserData] = useState([]);


  useEffect(() => {
    singleUser(auth?.user?.id).then((response) => {
      const tempUserData = response?.data?.user;
      setUserData(tempUserData);
      if (response?.data?.user) {

        if (tempUserData !== null) {
          // setFormData({
          //   firstName: tempUserData?.firstName,
          //   lastName: tempUserData?.lastName,
          //   email: tempUserData?.email,
          //   phoneNo: `${tempUserData?.countryCode} ${tempUserData?.phoneNo}`,
          //   countryCode: tempUserData?.countryCode,
          //   address: tempUserData?.createdBy?.address,
          //   country: tempUserData?.createdBy?.country?.code,
          //   state: tempUserData?.createdBy?.state?.code,
          //   city: tempUserData?.createdBy?.city,
          //   zipCode: tempUserData?.createdBy?.zipCode,
          //   currentPassword: "",
          //   newPassword: "",
          //   confirmNewPassword: ""
          // })
        }

        if (tempUserData?.expertiseAssign?.length) {
          tempUserData.expertiseAssign.map(item => setExpertiseList(prev => [...prev, item.expertise]));
        }
      }
    })
  }, []);

  const PasswordToggle = (e, field) => {
    e.preventDefault();
    // setShowPassword(prev => ({
    //   ...prev,
    //   [field]: !prev[field]
    // }));
  };


  const handleFormSubmit = async (values) => {
    const tempphoneNumber = values.phoneNo.split(' ').length > 1 ? values.phoneNo.split(' ')[1] : values.phoneNo.split('values.CountryCode')[0];
    const tempCountryCode = values.phoneNo.split(' ').length > 1 ? values.phoneNo.split(' ')[0] : values.CountryCode;
    // const userDetails = {
    //   userId: userData.id,
    //   first_name: values.firstName,
    //   last_name: values.lastName,
    //   phone_no: tempphoneNumber,
    //   country_code: tempCountryCode,
    //   old_password: values.currentPassword,
    //   password: values.newPassword,
    //   confirm_password: values.newPassword
    // };

    // updateUser(userData.id, userDetails).then((res) => {
    //   showAlert({
    //     title: "Users Notification",
    //     message: res?.message ?? "something went wrong, try again later",
    //     variant: "success",
    //   });

    //   setFormData(prev => ({
    //     ...prev,
    //     currentPassword: "",
    //     newPassword: "",
    //     confirmNewPassword: ""
    //   }));

    // }).catch((error) =>
    //   showAlert({
    //     title: "Users Notification",
    //     message: error?.data?.message ?? "something went wrong, try again later",
    //     variant: "danger",
    //   })
    // );
  }



  return (
    <>
      <MainWrapper>
        <CardWrapper className="full-box-0 p-0">


       



                <div className="p-4">
                  <h2 className="fs-5 fw-semibold text-gray-800 mb-4">Expertise</h2>
                  {expertiseList?.length ? (
                    <Row className="gy-4">
                      {expertiseList?.map(item => (
                        <Col md="3">
                          <div className="p-3 bg-gray-50 rounded-4">
                            <div className="d-flex align-items-center gap-3 w-100">
                              <ImagePreviewLightbox className="user-avtar user-avtar-56" src={(item?.images?.length > 0)  ? item?.images[0] : "/images/product-icon.png"}>
                                <Image
                                  className="object-fit-cover rounded-pill"
                                  src={(item?.images?.length > 0)  ? item?.images[0] : "/images/product-icon.png"}
                                  width={56}
                                  height={56}
                                  alt="Product Icon"
                                />
                              </ImagePreviewLightbox>
                              <div>
                                <p className="fs-16 fw-semibold text-gray-700 mb-1">
                                  {item.name}
                                </p>
                                {/*<p className="fs-14 fw-normal text-gray-500 mb-0">
                                  Brand Name
                                </p>*/}
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  ) : (<Row className="gy-4">
                    <Col md="12">
                      <div className="p-3 bg-gray-50 rounded-4">
                        No Expertise added
                      </div>
                    </Col>
                  </Row>)}

                </div>

        </CardWrapper>
      </MainWrapper>
    </>
  );
};

export default ProfileOverviewExpertise;
